import { useTranslations } from '@npco/utils-translations'
import { Box } from '@npco/zeller-design-system'
import { DefaultLegendContentProps } from 'recharts'

import { translations } from './ChartLegend.i18n'
import * as styled from './ChartLegend.styled'

export const ChartLegend = ({ payload }: DefaultLegendContentProps) => {
  const t = useTranslations(translations)

  return (
    <styled.ChartLegendWrapper as="ul">
      {(payload ?? []).map((entry) => (
        <styled.ChartLegendItem as="li" key={`item-${entry.value}`}>
          <Box
            as="span"
            width={10}
            height={10}
            backgroundColor={entry.color}
            borderRadius={3}
          />
          <span>{entry.dataKey === 'income' ? t('income') : t('expense')}</span>
        </styled.ChartLegendItem>
      ))}
    </styled.ChartLegendWrapper>
  )
}
